import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const LS_KEY = 'lang';
const SUPPORTED = new Set(['es', 'en', 'pt']);
const DEFAULT_LANG = 'es';

/**
 * Adjunta `Accept-Language: <lang>` (es | en | pt) a cada request del API propio.
 * El backend resuelve captions/labels via `IStringLocalizer<T>` (ver
 * docs/migration/_i18n.md sección 3 — textos dinámicos del backend).
 *
 * NO inyectamos `LanguageService` aquí: causaría un ciclo HTTP_INTERCEPTORS ↔
 * LanguageService (porque el constructor del service dispara una HTTP de carga
 * del JSON, que a su vez intenta resolver el interceptor, que necesita el
 * service todavía construyéndose). En su lugar leemos el idioma directamente
 * de `localStorage` — es donde el LanguageService persiste y es la única
 * fuente de verdad cross-tab.
 *
 * Las requests que NO son del API propio (p. ej. `assets/i18n/*.json`) pasan
 * sin tocar el header — esto evita además que la propia carga de los JSON de
 * traducción dispare el interceptor.
 */
@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isApiCall =
      req.url.startsWith('/api/') ||
      req.url.startsWith(environment.apiUrl);

    if (!isApiCall) return next.handle(req);

    const cloned = req.clone({
      setHeaders: { 'Accept-Language': this.readLang() },
    });
    return next.handle(cloned);
  }

  private readLang(): string {
    try {
      const v = localStorage.getItem(LS_KEY);
      if (v && SUPPORTED.has(v)) return v;
    } catch { /* localStorage bloqueado en algunos browsers privados */ }
    return DEFAULT_LANG;
  }
}
